import { HorizontalBar } from 'vue-chartjs'

export default {
  name: 'HorizontalGroupedBarChart',
  extends: HorizontalBar,
  props: {
    chartJs: { type: Object, required: true }, // { data, options }
  },
  mounted() {
    this.render()
  },
  watch: {
    chartJs: {
      deep: true,
      handler() {
        this.render()
      },
    },
  },
  methods: {
    render() {
      this.renderChart(this.chartJs.data, this.chartJs.options)
    },
  },
}

